"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = _interopRequireDefault(require("../../Text/Text"));

// This component is to fill the gap between InfoCircle and the hover info
var HoverInfoStyle = _styledComponents.default.div.withConfig({
  displayName: "HoverInfo__HoverInfoStyle",
  componentId: "sc-13ghqig-0"
})(["position:absolute;background:white;color:white;right:-5px;width:5px;top:20px;cursor:default;"]);

var HoverInfo = function HoverInfo(_ref) {
  var className = _ref.className,
      hoverInfoDescriptions = _ref.hoverInfoDescriptions;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    color: "#ccc"
  }, hoverInfoDescriptions), /*#__PURE__*/_react.default.createElement(HoverInfoStyle, null, "."));
};

HoverInfo.propTypes = {
  className: _propTypes.default.string,
  hoverInfoDescriptions: _propTypes.default.string
};

var _default = (0, _styledComponents.default)(HoverInfo).withConfig({
  displayName: "HoverInfo",
  componentId: "sc-13ghqig-1"
})(["display:inline-block;position:absolute;top:-20px;right:20px;width:215px;padding:15px;background:#333;z-index:500;> p > a{color:#fff;}"]);

exports.default = _default;